import { 
  GET_HARDNESS_TEST_FAILURE, 
  GET_HARDNESS_TEST_REQUEST, 
  GET_HARDNESS_TEST_SUCCESS 
} from "./hardnessTypes";

const initialState = {
  loading: false,
  hardnessTest: [],
  error: "",
};

const getHardnessTestReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HARDNESS_TEST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_HARDNESS_TEST_SUCCESS:
      return {
        loading: false,
        hardnessTest: action.payload,
        error: "",
      };
    case GET_HARDNESS_TEST_FAILURE:
      return {
        loading: false,
        hardnessTest: [],
        error: action.payload,
      };
    default:
      return state; 
  }
};

export { getHardnessTestReducer };